import getWithToken from './base/get-with-token'

const getUsersList = getWithToken('/user')

export default getUsersList